import { BREAKPOINTS } from '../constants.js'

export function isMobile() {
    if (window.innerWidth <= BREAKPOINTS.mobile) return true
}
